import React from 'react'
import gql from 'graphql-tag'
import {productIsDelivered} from 'lib/productHelpers'
import DeliveredFloorPlans from 'components/shared/DeliveredFloorPlans'
import ProductInputAssets from 'components/shared/ProductInputAssets'
import DefaultProductStatus from '../../DefaultProductStatus'

const DigitalPlanDrawingProduct = ({match, product}) => {
  if (product.canProvideUserInput) {
    return (
      <ProductInputAssets
        product={product}
        description={
          <>
            <p>Last opp underlag for plantegning 2D.</p>
          </>
        }
      />
    )
  }
  if (productIsDelivered(product)) {
    return (
      <DeliveredFloorPlans
        product={product}
        estateId={match.params.estateId}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

DigitalPlanDrawingProduct.fragment = gql`
  fragment DigitalPlanDrawingProduct on DigitalPlanDrawingProduct {
    extraAssetUnitPrice
    remainingCredits
    assets {
      edges {
        approved
        node {
          id
          state
          ...on PlanDrawingCorrectionAsset { url }
          ...on PlanDrawingAsset {
            free
            assets {
              edges {
                node {
                  id
                  ...on PhotoAsset {
                    image(size: "monitor") {
                      url
                      thumbUrl
                      width
                      height
                      labels
                      filenameIndex
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    order {
      expressDelivery
    }
    correctionUrls {
      name
      url
    }
  }
`

export default DigitalPlanDrawingProduct
